import { capitalizeIfNot, getVisibleName, maskNameByIndex } from "./maskName";

export function getFullName(
  firstName: string | undefined,
  lastName: string | undefined,
  reverseOrder?: boolean,
  mask?: boolean,
  abbreviationIndex?: number,
  abbreviate?: boolean
): string {
  const firstPart = capitalizeIfNot(firstName);
  const secondPart = capitalizeIfNot(lastName);

  // prevent returning "undefined" or "null" as a string
  if (!firstPart && !secondPart) {
    return "-";
  }

  return reverseOrder
    ? `${secondPart} ${mask ? maskNameByIndex(firstPart, abbreviationIndex) : abbreviate ? getVisibleName(firstPart, abbreviationIndex) : firstPart}`
    : `${firstPart} ${mask ? maskNameByIndex(secondPart, abbreviationIndex) : abbreviate ? getVisibleName(secondPart, abbreviationIndex) : secondPart}`;
}
